export const DashboardCarousel = {
  transclude: {
    carouselBody: '?dashboardCarouselBody',
    carouselFooter: '?dashboardCarouselFooter',
    carouselHeader: '?dashboardCarouselHeader',
  },

  template: `
    <div class="dashboard-carousel pt-3 bg-white">
      <div class="container pt-3 pt-md-4">
        <div class="dashboard-carousel-header"
          ng-transclude="carouselHeader">
        </div>
        <div class="dashboard-carousel-body mb-md-3"
          ng-transclude="carouselBody">
        </div>
        <div class="dashboard-carousel-footer">
          <div class="d-flex justify-content-center align-items-center pb-3"
            ng-transclude="carouselFooter">
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Carousel.js